import React, { useMemo } from "react";
import ModalPortal from "components-new/ModalPortal";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import sass from "./style.module.sass";

interface IModal {
	mode: "update" | "remove";
	show: boolean;
	close: () => void;
	ok?: () => void;
}

export const ModalAccept: React.FC<IModal> = ({ show, mode, close, ok }) => {
	const content = useMemo(() => {
		const isRemove = mode === "remove";
		return {
			title: isRemove ? "Откат шаблона" : "Обновление шаблона",
			message: isRemove
				? "Вы собираетесь откатить текущую версию шаблона до системного"
				: "Вы собираетесь обновить системный шаблон",
		};
	}, [mode]);

	const confirm = () => {
		if (ok) {
			ok();
			close();
		}
	};

	return show ? (
		<ModalPortal title={content.title} outSide={false} handleClose={close}>
			<div className={sass.modal_content}>
				<div className={sass.text}>{content.message}</div>
				<div className={sass.btns}>
					<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
						Отменить
					</Button>
					<Button onClick={confirm} variant={BUTTON_VARIANTS.CONTAINED}>
						Продолжить
					</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};
